import { render, staticRenderFns } from "./standart-user-modal.vue?vue&type=template&id=42cf4ed2&"
import script from "./standart-user-modal.vue?vue&type=script&lang=ts&"
export * from "./standart-user-modal.vue?vue&type=script&lang=ts&"
import style0 from "./standart-user-modal.vue?vue&type=style&index=0&id=42cf4ed2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports